var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M0.5 30C0.223858 30 -0.00062982 29.7746 0.00616355 29.4986C0.272279 18.6846 9.12194 10 20 10C30.8781 10 39.7277 18.6846 39.9938 29.4986C40.0006 29.7746 39.7761 30 39.5 30H31.7C31.4239 30 31.2012 29.7756 31.189 29.4997C30.9273 23.5463 26.018 18.8 20 18.8C13.982 18.8 9.07266 23.5463 8.81097 29.4997C8.79885 29.7756 8.57614 30 8.3 30H0.5Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M0.500001 29.9998C0.223858 29.9998 -0.000652782 29.7759 0.00624959 29.4999C0.0861638 26.3037 0.931304 23.1707 2.47387 20.3648C4.09679 17.4127 6.43911 14.9184 9.28347 13.1133L13.9987 20.5434C12.4059 21.5542 11.0942 22.951 10.1854 24.6042C9.35693 26.1111 8.8877 27.7865 8.81116 29.5C8.79884 29.7759 8.57614 29.9998 8.3 29.9998H0.500001Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.532a71b47c8a224b067bc1577d36eba3.svg";
export { ForwardRef as ReactComponent };